<app-spinner [loading]="saving() || calistLoading() || profilesLoading()"></app-spinner>
@if(drilldown()) {
  <app-profile-details [value]="drilldown()" (back)="onBack()"></app-profile-details>
}
@else if(edit()) {
  <app-profile-form [edit]="edit()"
  [certificationAuthorities]="certificationAuthorities()"
  (updateProfile)="onUpdate($event)" (cancelOperation)="onCancel({ confirmation:
  false })"></app-profile-form>
}
@else if(clone()) {
  <app-profile-form [clone]="clone()"
  [certificationAuthorities]="certificationAuthorities()"
  (createProfile)="onClone($event)" (cancelOperation)="onCancel({ confirmation:
  false })"></app-profile-form>
}
@else {
  <app-profilelist-main-table></app-profilelist-main-table>
}
